import axios from 'axios'
import store from '@/store'

const API_BASE_URL = process.env.VUE_APP_API_URL || 'https://clubtest.intrare.app'

const request = (method, path, { data, params, headers } = {}) => axios({
  method,
  url: `${API_BASE_URL}${path}`,
  headers: Object.assign({
    'Content-Type': 'application/json',
    'Accept-Language': store.state.language,
    'authorization': 'Token ' + store.getters.getToken
  }, headers),
  data,
  params
})

// Panel del staff (administrador de gimnasio o coach)
export const getStaffSummary = () => request('get', '/fitness/admin/summary/')

// Coaches. El alta usa el CRUD de administradores con fitness_coach = true
export const getCoaches = () => request('get', '/fitness/admin/coaches/')
export const getCoachRatings = (id, params) => request('get', `/fitness/admin/coaches/${id}/ratings/`, { params })
export const uploadCoachAvatar = (id, file) => {
  const form = new FormData()
  form.append('image', file)
  return request('post', `/fitness/admin/coaches/${id}/avatar/`, {
    data: form,
    headers: { 'Content-Type': 'multipart/form-data' }
  })
}
export const revokeCoach = id => request('delete', `/fitness/admin/coaches/${id}/`)
export const createCoach = data => request('post', '/administrator_manager/', {
  data,
  headers: { 'Content-Type': 'multipart/form-data' }
})

// Socios del club
export const getMembers = params => request('get', '/fitness/admin/members/', { params })
// Socios vinculados al coach (o a todos los coaches, para el admin) por una asignacion activa o en pausa
export const getLinkedMembers = params => request('get', '/fitness/admin/my-members/', { params })

// Biblioteca de rutinas del staff
export const getLibraryRoutines = params => request('get', '/fitness/admin/routines/', { params })
export const createLibraryRoutine = data => request('post', '/fitness/admin/routines/', { data })
export const updateLibraryRoutine = (id, data) => request('put', `/fitness/admin/routines/${id}/`, { data })
export const deleteLibraryRoutine = id => request('delete', `/fitness/admin/routines/${id}/`)

// Asignaciones
export const getAssignments = params => request('get', '/fitness/admin/assignments/', { params })
export const createAssignment = data => request('post', '/fitness/admin/assignments/', { data })
export const getAssignment = id => request('get', `/fitness/admin/assignments/${id}/`)
export const updateAssignment = (id, data) => request('patch', `/fitness/admin/assignments/${id}/`, { data })
export const getAssignmentProgress = id => request('get', `/fitness/admin/assignments/${id}/progress/`)
export const getHistory = params => request('get', '/fitness/admin/history/', { params })

// Catalogo y metadatos
export const getExercises = params => request('get', '/fitness/exercises/', { params })
export const getFitnessMeta = () => request('get', '/fitness/meta/')

export const ASSIGNMENT_STATUSES = [
  { value: 'active', text: 'Activa', color: 'green' },
  { value: 'paused', text: 'Pausada', color: 'orange' },
  { value: 'completed', text: 'Completada', color: 'blue' },
  { value: 'cancelled', text: 'Cancelada', color: 'red' }
]

export const ASSIGNMENT_ACTIONS = {
  assigned: { text: 'Nueva asignación', color: 'primary' },
  updated: { text: 'Modificación', color: 'warning' },
  paused: { text: 'Pausada', color: 'orange' },
  resumed: { text: 'Reanudada', color: 'green' },
  completed: { text: 'Completada', color: 'blue' },
  cancelled: { text: 'Cancelada', color: 'red' },
  reassigned: { text: 'Cambio de coach', color: 'purple' }
}

export const statusInfo = status => ASSIGNMENT_STATUSES.find(s => s.value === status) || { text: 'Desconocido', color: 'grey' }

// Convierte un error del API ({detail, code, campo: [mensajes]}) en un texto para mostrar
export const apiErrorMessage = (error, fallback = 'Ocurrió un error. Intenta de nuevo.') => {
  const data = error && error.response && error.response.data
  if (!data || typeof data === 'string') return fallback
  const fields = Object.entries(data)
    .filter(([key]) => !['detail', 'code'].includes(key))
    .map(([key, value]) => `${key}: ${JSON.stringify(value).replace(/[[\]{}"]/g, '')}`)
  return [data.detail].concat(fields).filter(Boolean).join(' · ') || fallback
}

// 'YYYY-MM-DD' se interpreta como fecha local (evita el desfase de un dia por UTC)
export const formatDate = value => {
  if (!value) return ''
  const date = new Date(value.length === 10 ? `${value}T00:00:00` : value)
  return date.toLocaleDateString('es-MX', { year: 'numeric', month: 'short', day: 'numeric' })
}

export const formatTime = value => {
  if (!value) return ''
  return new Date(value).toLocaleTimeString('es-MX', { hour: '2-digit', minute: '2-digit' })
}
